export default __webpack_public_path__ + "static/media/landing-page-bg.dc427449.svg";